import React from 'react';
import InputMask from 'react-input-mask';

function CelularMaskInput({ value, onChange, disabled, size, ...rest }) {
  const sizeClass =
    size === 'sm' ? 'form-control-sm' : size === 'lg' ? 'form-control-lg' : '';
  const className = `form-control ${sizeClass}`.trim();

  return (
    <InputMask
      mask="(99) 99999-9999"
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      {inputProps => <input {...inputProps} {...rest} className={className} />}
    </InputMask>
  );
}

export default CelularMaskInput;
